import { render, staticRenderFns } from "./WizardNav.vue?vue&type=template&id=664fa6ca&scoped=true&"
import script from "./WizardNav.vue?vue&type=script&lang=js&"
export * from "./WizardNav.vue?vue&type=script&lang=js&"
import style0 from "./WizardNav.vue?vue&type=style&index=0&id=664fa6ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664fa6ca",
  null
  
)

export default component.exports